<template lang="pug">
  .popup(v-if="show")
    .popup-container
      img.close-icon(:src="CloseIcon" @click="closeModal")
      .rights-title
        .left-rights-wrap
          img.left-rights-icon(:src="rightsData.joinMemberIcon")
        .right-title-group
          .main-title {{ rightsData.additionalName }}
          .sub-title 将发放至你绑定的手机号（请仔细确认）
      .rights-content
        input(v-model='phone',type='tel',maxlength='11',placeholder='请输入手机号')
        .receive-desc
          span.highlight 每月需手动领取，
          span 领取后不可退
        .button(
          @click="handleSubmit"
          :class="{'button-enable':validPass&&recieveStatus===UnionRightsStatus.WAIT_RECEIVE,'button-disabled':!validPass||recieveStatus===UnionRightsStatus.RECEIVED}") 确认
    .mask(@click="closeModal")
  </template>
<script>
import { CloseIcon } from '@/assets/imgAssets.js';
import { UnionRightsStatus } from '@/const/vip';
import { PHONE_REG } from '@/utils/regexp.js';
import Toast from '@/components/toast';
import { receiveVipCoupon } from '@/api/vip';
import { getSystemCode } from '@/utils/systemCode';
import { getTokenAndKey } from '@/utils/index';

export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    rightsData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      CloseIcon,
      UnionRightsStatus,
      phone: '',
      // 领取状态
      recieveStatus: UnionRightsStatus.WAIT_RECEIVE,
    };
  },
  computed: {
    validPass() {
      if (!this.phone) return false;
      return PHONE_REG.test(this.phone);
    },
  },
  created() {

  },
  mounted() {
  },
  methods: {
    async handleSubmit() {
      // 校验电话号码
      if (!this.phone) {
        Toast.show('请输入手机号');
        return;
      }
      if (!PHONE_REG.test(this.phone)) {
        Toast.show('请输入11位有效号码');
      }
      try {
        const { token } = await getTokenAndKey();
        await receiveVipCoupon({
          token,
          userVipPropGuid: this.rightsData.userVipPropGuid,
          propCode: this.rightsData.propCode,
          systemCode: getSystemCode(),
          mobile: this.phone,
        });
        Toast.show('领取成功');
        this.$emit('refreshData');
        this.closeModal();
      } catch (e) {
        Toast.showError(e);
      }
    },

    closeModal() {
      this.$emit('close');
      this.$emit('update:show', false);
    },
  },
};
</script>
<style lang="less" scoped>
.popup {
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;

  .popup-container {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 222;
    height: 2.93rem;
    width: 100%;
    border-radius: 0.16rem 0.16rem 0 0;
    color: #242729;
    padding: 0.18rem 0.16rem 0 0.16rem;
    background: url('https://m.hellobike.com/resource/gallery/59/ObdTjn1_t3.png');
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .close-icon {
    width: 0.22rem;
    height: 0.22rem;
    position: absolute;
    right: 0.06rem;
    top: 0.08rem;
  }

  .rights-title {
    display: flex;

    .left-rights-wrap {
      width: 0.38rem;
      height: 0.38rem;
      border-radius: 0.1rem;
      margin-right: 0.09rem;
    }

    .left-rights-icon {
      width: 0.38rem;
      height: 0.38rem;
    }

    .right-title-group {
      display: flex;
      flex-direction: column;
      font-family: PingFang SC;

      .main-title {
        font-size: 0.16rem;
        font-weight: 500;
        color: rgba(111, 37, 0, 1);
      }

      .sub-title {
        font-weight: 400;
        font-size: 0.13rem;
        color: rgba(125, 59, 42, 1);
      }
    }
  }

  .rights-content {
    margin-top: 0.3rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    input {
      border-radius: 0.1rem;
      width: 100%;
      height: 0.48rem;
      font-size: 0.18rem;
      outline: none;
      padding: 0.02rem 0.1rem;
      -webkit-appearance: none;
      background-color: rgba(255, 255, 255, 1);
      text-align: center;
      font-weight: 400;

    }
    input::-webkit-input-placeholder {
      font-size: 0.2rem;
      font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
      font-weight: 500;
      color: rgba(36, 39, 41, 1);
      line-height: 0.22rem;
      opacity: 0.2;
    }

    .receive-desc {
      font-size: 0.12rem;
      font-weight: 400;
      line-height: 1;
      color: rgba(36, 39, 41, 1);
      margin-top: 0.08rem;
      font-family: PingFang SC;
    }

    .highlight {
      color: rgba(255, 87, 41, 1);
    }

    .button {
      height: 0.52rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(255, 255, 255, 1);
      font-size: 0.18rem;
      font-weight: 500;
      border-radius: 0.12rem;
      width: 100%;
      margin-top: 0.16rem;
    }

    .button-enable {
      background: linear-gradient(to right, rgba(250, 134, 33, 1), rgba(250, 58, 0, 1));
    }

    .button-disabled {
      background-color: rgba(188, 196, 204, 1);
    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 220;
  }
}
</style>
